import { SkillCategory } from '@/data/types';
import { useData } from '@/i18n/LangContext';

interface CvSkillsProps {
  categories?: SkillCategory[];
  showVerified?: boolean;
  customCategories?: {
    name: string;
    skills: string[];
  }[];
}

export default function CvSkills({ 
  customCategories
}: CvSkillsProps) {
  const { ui } = useData();
  // Verwende benutzerdefinierte Kategorien, wenn sie vorhanden sind
  const skillsToRender = customCategories || [
    {
      name: `${ui.cv.skillsTech}/${ui.cv.skillsLangs}`.toUpperCase(),
      skills: ["HTML", "CSS", "Javascript/Typescript", "SVG", "Dart (Flutter)", "Python", "PHP", "SQL", "Swift", "Docker", "REST", "JSON", "XML", "GitHub", "GitLab", "Shopware 6", "Canvas", "WebSockets", "Tailwind CSS", "Bootstrap"]
    },
    {
      name: "TOOLS",
      skills: ["Node", "Webpack", "Vite", "Parcel", "Grunt", "Gulp", "Git", "SVN", "Shell", "Docker", "npm", "Yarn", "Composer", "Postman", "Figma", "Sketch", "Photoshop"]
    },
    {
      name: "FRAMEWORKS / LIBRARIES",
      skills: ["NextJS", "ReactJS", "Tailwind", "GSAP", "SCSS", "LESS", "Stylus", "Cypress", "Twig", "Smarty", "Flutter", "Shopware Headless", "Shopware 6 Storefront"]
    },
    {
      name: "SOFTWARE",
      skills: ["VSC", "Jetbrains", "Android Studio", "Xcode", "Cursor AI", "Photoshop", "GTM", "Google Analytics", "NextJS App Router", "Cloudflare", "Windows", "Linux", "macOS", "Sketch", "Figma", "Shopware", "Jira", "Mantis", "Omniture", "Illustrator", "Animate"]
    },
    {
      name: ui.cv.skillsConcepts.toUpperCase(),
      skills: ["CI/CD", "Shell", "RESTful API", "Server & Domain Management", "Microservices", "Debian", "Raspberry Pi", "Synology", "Responsive/Adaptive Design", "Animations", "OOP", "Functional Programming", "Debugging", "Design Patterns", "Browser Optimization", "SEO", "UX Design", "Documentation", "Testing", "Apple App Store", "Google Play Store", "Code-Signing (Google/Apple)"]
    }
  ];

  return (
    <div className="space-y-6 print:space-y-2">
      {skillsToRender.map((category, index) => (
        <div key={index} className="mb-6 print:mb-4 last:mb-0">
          <h3 className="text-lg font-semibold text-white mb-3 print:text-black print:mb-2 print:text-base">{category.name}</h3>
          
          <div className="flex flex-wrap gap-4 print:gap-1.5">
            {category.skills.map((skill, skillIndex) => (
              <span 
                key={skillIndex} 
                className="px-3 py-1.5 rounded-full text-sm font-mono bg-[rgba(198,156,109,0.1)] border border-[rgba(198,156,109,0.2)] text-[#C69C6D] print:bg-white print:text-black print:border-gray-300 print:py-1 print:text-xs"
              >
                {skill}
              </span>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
} 